import * as React from "react";
import * as cn from "classnames";
import { createElement } from "react-faux-dom";

export interface D3ContainerProps {
    className?: string;
}

export interface D3ChartRenderSettings {
    x: number;
    y: number;
    width: number;
    height: number;
}

export abstract class D3StaticChartOptimizedContainer<TProps> extends React.Component<TProps & D3ContainerProps> {
    render() {
        const settings = this.getChartRenderSettings();

        const svg = createElement("svg");

        svg.setAttribute("width", settings.width.toString());
        svg.setAttribute("height", settings.height.toString());
        svg.className = cn(this.props.className);
        svg.setAttribute("viewBox", `${settings.x} ${settings.y} ${settings.width} ${settings.height}`);

        this.renderChart((svg as any) as SVGSVGElement, this.props, settings);

        return svg.toReact();
    }

    /**
     * Render a chart as it is new.
     * Chart DOM updating will be optimized by react.
     *
     * Notice that some interactive charts will not work, and would need to use a D3RawDomContainer.
     */
    abstract renderChart(element: SVGSVGElement, props: Readonly<TProps>, settings: D3ChartRenderSettings): void;

    getChartRenderSettings(): D3ChartRenderSettings {
        return {
            x: 0,
            y: 0,
            width: 100,
            height: 100
        };
    }
}
